import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { PageViewMappingApi, UsersApi, UserTypeApi,WorkerApi } from 'shared/sdk';
import { AppStateService } from 'shared/services/app-state.service';
import { debounceTime, distinctUntilChanged, switchMap, filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { CommonService } from 'shared/services/common.service';

@Component({
  selector: 'app-worker-users-look-up',
  templateUrl: './worker-users-look-up.component.html',
  styleUrls: ['./worker-users-look-up.component.css']
})
export class WorkerUsersLookUpComponent implements OnInit, OnDestroy {

  @Input() set resetData(isClear) {
    this.workerUserIdSelected = [];
  }
  @Input() from;
  @Input() selectLabel = 'Name';
  @Input() selectbindValue = 'user.sfdcId';
  @Input() isMultiSelect = 'false';
  @Input() set selectPageName(e) {
    if (e) {
      this.pageNameList = [];
      this.pageNameList.push(e);
      this.workerUserIdSelected = e && e.user && e.user.id;
    }
  }
  // @Input() set preSelected(e) {
  //   if (e) {
  //     this.userIdSelected = e
  //     this.onPageNameChange()
  //   }
  // }
  @Input() isDisabled = false;
  @Output() getPageNameObj: EventEmitter<any> = new EventEmitter;

  // vendor User

  noPageName = 'Searching...';
  pageNameahead = new EventEmitter<string>();
  pageNameList = [];
  workerUserIdSelected = [];
  isMultipleSelected = true;
  maxSelectedItems = 1;
  isMobile = false;

  constructor(
    private _usersApi: UsersApi,
    private _workerApi: WorkerApi,
    private _commonService: CommonService,
  ) { }

  ngOnInit() {
    this.getPageName();
    const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
    this.workerUserIdSelected = (preselected && preselected['workerUserIdLookup']) ?
      preselected['workerUserIdLookup'] : '';
    if (this.workerUserIdSelected) {
      const obj = { id: this.workerUserIdSelected };
      this.getPageNameList(obj).subscribe(x => {
        if (x && x.length) {
          this.pageNameList = x.map(user => {
            let Name = '';
            if (user['firstname']) {
              Name = Name + user['firstname'];
            }
            if (user['lastname']) {
              Name = Name + user['lastname'];
            }
            user['Name'] = Name;
            return user;
          });
        } else {
          this.pageNameList = [];
        }
        this.noPageName = (this.pageNameList.length === 0) ? 'No User found.' : '';
      },
        err => {
          console.log(err);
          this.pageNameList = [];
          this.noPageName = '';
        })
    }
    // this.onPageNameChange();
  }

  getPageName() {
    this.pageNameahead.pipe(
      filter(term => term && term.length > 2),
      distinctUntilChanged(),
      debounceTime(200),
      switchMap(term => {
        let toSearch: any = term.trim();
       // toSearch = toSearch.split(' ');
        let whereObj = {};

        if (toSearch) { //FIRST NAME CHECK
          whereObj = {
            Name: { ilike: '%' + toSearch + '%', options: 'i' },
            is_FTE_Worker__c: 1
          }
        }

        return this.getPageNameList(whereObj);
      })
    ).subscribe(
      x => {
        if (x && x.length) {
          this.pageNameList = x.map(user => {
            let Name = '';
            if (user['Name']) {
              Name = Name + user['Name'];
            }
            user['Name'] = Name;
            return user;
          });
        } else {
          this.pageNameList = [];
        }
        this.noPageName = (this.pageNameList.length === 0) ? 'No User found.' : '';
      },
      err => {
        console.log(err);
        this.pageNameList = [];
        this.noPageName = '';
      }
    );
  }

  onPageNameChange() {
    this.getPageNameObj.emit(this.workerUserIdSelected);
  }

  clearPrograms() {
    this.workerUserIdSelected = [];
    this.getPageNameObj.emit({});
  }

  getPageNameList(whereObj) {

    let includeObj = {
      include: [
      {
        relation : 'user',
        scope : {
          fields : ['sfdcId', 'firstname', 'lastname', 'id'],
        }
      }
    ]}

    return this._workerApi.find({
      where: whereObj,
      fields: ['Name', 'Contact__c', 'id', 'sfdcId'],
      ...includeObj,
    }).map(res => res);
  }

  ngOnDestroy() { }

}
